import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PURPOSE } from 'domains/internal-request/constants'

const propTypes = {
  purpose: PropTypes.string
}

/**
 * To give nice look on Internal Request `purpose`.
 * It maps `purpose` to certain style.
 * @param {string} status Internal Request purpose
 */
const InternalRequestPurposeBadge = ({ purpose }) => {

  const colorMap = {
    [PURPOSE.BAZAAR]     : 'warning',
    [PURPOSE.PHOTOGRAPH] : 'success',
    [PURPOSE.PHOTOSHOOT] : 'success',
    [PURPOSE.TINKERJOY]  : 'primary'
  }

  const color = colorMap[purpose]

  return <StatusBadge color={ color } label={ purpose } />
}

InternalRequestPurposeBadge.propTypes = propTypes

export default InternalRequestPurposeBadge
